// Admin API helpers. All requests are same-origin and rely on the secure,
// HTTP-only session cookie (credentials: 'include'). No tokens in URLs.
const BACKEND = process.env.REACT_APP_BACKEND_URL;

export async function adminMe() {
  try {
    const r = await fetch(`${BACKEND}/api/admin/me`, { credentials: "include" });
    return await r.json();
  } catch {
    return { authenticated: false, login_enabled: false };
  }
}

export async function adminLogin(password) {
  const r = await fetch(`${BACKEND}/api/admin/login`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ password }),
  });
  const data = await r.json().catch(() => ({}));
  return { status: r.status, data };
}

export async function adminLogout() {
  try {
    await fetch(`${BACKEND}/api/admin/logout`, { method: "POST", credentials: "include" });
  } catch {
    /* ignore */
  }
}

function cleanParams(params) {
  const out = {};
  Object.entries(params || {}).forEach(([k, v]) => {
    if (v !== "" && v !== null && v !== undefined) out[k] = v;
  });
  return out;
}

export async function adminSubmissions(params) {
  const qs = new URLSearchParams(cleanParams(params)).toString();
  const r = await fetch(`${BACKEND}/api/admin/submissions?${qs}`, { credentials: "include" });
  const data = await r.json().catch(() => ({}));
  return { status: r.status, data };
}

export async function downloadAdminCsv(kind, params) {
  const qs = new URLSearchParams(cleanParams(params)).toString();
  const res = await fetch(`${BACKEND}/api/admin/export/${kind}?${qs}`, { credentials: "include" });
  if (res.status !== 200) {
    const msg = res.status === 401 ? "Your session expired. Please sign in again." : "Export failed.";
    throw new Error(msg);
  }
  const blob = await res.blob();
  const cd = res.headers.get("Content-Disposition") || "";
  const match = cd.match(/filename="?([^";]+)"?/);
  const filename = match ? match[1] : `${kind}`;
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export function adminPolicyFileUrl(policyReviewSubmissionId) {
  return `${BACKEND}/api/admin/submissions/${policyReviewSubmissionId}/policy-file`;
}

export async function adminMissedNotifications() {
  const r = await fetch(`${BACKEND}/api/admin/notifications/missed`, { credentials: "include" });
  const data = await r.json().catch(() => ({}));
  return { status: r.status, data };
}

export async function adminSendCatchUp() {
  const r = await fetch(`${BACKEND}/api/admin/notifications/send-catch-up`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ confirm: true }),
  });
  const data = await r.json().catch(() => ({}));
  return { status: r.status, data };
}

export const FORM_OPTIONS = [
  ["", "All forms"],
  ["7-steps", "7 Simple Steps to Becoming Your Own Banker"],
  ["legacy-builder", "Legacy Builder Outline"],
  ["budget-template", "Budget Template + Training"],
  ["infinite-banking-guide", "The Infinite Banking Guide"],
  ["save-spend-overview", "Save & Spend System Overview"],
  ["newsletter", "Weekly Newsletter"],
  ["policy-review", "Free Policy Review"],
];
